import React from 'react';
import { useRecoilValue } from 'recoil';
import { dimensionsAtom } from 'pages/dimensions/store/dimensions';
import { Param } from '../RoomParam';

export const TypeInstallationComponent: React.FC = () => {
  const dimensions = useRecoilValue(dimensionsAtom);
  const { surface } = dimensions;
  const typeInstallation =
    surface.FLOOR?.typeInstallation || surface.WALL?.typeInstallation || surface.CEILING?.typeInstallation;

  if (typeInstallation) {
    return <Param label="Направление укладки" value={typeInstallation} />;
  }

  return null;
};
